import type { ReactNode } from 'react';

export function PageHeader({
  kicker,
  title,
  description,
  actions,
}: {
  kicker: string;
  title: string;
  description?: string;
  actions?: ReactNode;
}) {
  return (
    <div className="mb-8">
      <div className="kicker kicker-brand mb-2">{kicker}</div>
      <div className="flex items-end justify-between gap-4">
        <div className="min-w-0">
          {/* Serif heading for warm boutique feel */}
          <h1 className="serif text-[34px] leading-[1.05] text-ink-800 font-semibold">{title}</h1>
          {description && (
            <p className="text-[13.5px] text-ink-500 mt-2.5 max-w-2xl tracking-tight leading-relaxed">{description}</p>
          )}
        </div>
        {actions && <div className="flex items-center gap-2 shrink-0">{actions}</div>}
      </div>
      <div className="divider mt-7" />
    </div>
  );
}
